import { useState } from 'react';

const RESERVATION_URL = 'https://upnow.jp/duel';

export default function FloatingReservation() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating side tab */}
      <div className="fixed right-0 top-1/2 -translate-y-1/2 z-40 flex items-center">
        <button
          onClick={() => setOpen(true)}
          className="flex flex-col items-center justify-center bg-[#d4af37] text-black py-5 px-2.5 rounded-l-xl cursor-pointer hover:bg-[#e8c84a] transition-all duration-200 gap-1.5"
          aria-label="予約する"
          style={{ writingMode: 'vertical-rl' }}
        >
          <i
            className="ri-calendar-check-line text-black"
            style={{ writingMode: 'horizontal-tb', fontSize: '18px' }}
          />
          <span className="font-noto font-bold text-black text-xs tracking-widest">
            今すぐ予約（登録不要）
          </span>
        </button>
      </div>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/70 backdrop-blur-sm"
            onClick={() => setOpen(false)}
          />

          {/* Modal content */}
          <div className="relative bg-[#1a1f2e] rounded-2xl w-full max-w-lg border border-[#2a2f3e] z-10 overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-[#2a2f3e]">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#d4af37]/20 rounded-lg">
                  <i className="ri-poker-hearts-line text-[#d4af37] text-lg" />
                </div>
                <div>
                  <h3 className="font-playfair font-bold text-white text-base">ご予約</h3>
                  <p className="text-white/40 text-xs font-noto">ポーカーレンタルスペース デュエル</p>
                </div>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-white text-lg" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6">
              <p className="text-white/60 font-noto text-sm leading-relaxed mb-6">
                外部予約サイトへ移動します。<br />
                スマートロックのパスワードは予約完了メールにてご確認ください。
              </p>

              {/* Quick info */}
              <div className="grid grid-cols-3 gap-3 mb-6">
                {[
                  { icon: 'ri-time-line', label: '24時間', sub: '年中無休' },
                  { icon: 'ri-coin-line', label: '¥550（税込）〜', sub: '1時間/1卓' },
                  { icon: 'ri-map-pin-line', label: '徒歩5分', sub: '秋葉原・神田' },
                ].map((info) => (
                  <div
                    key={info.label}
                    className="bg-[#2a2f3e] rounded-xl p-3 text-center"
                  >
                    <div className="w-8 h-8 flex items-center justify-center mx-auto mb-1.5">
                      <i className={`${info.icon} text-[#d4af37] text-lg`} />
                    </div>
                    <p className="text-white font-bold text-xs">{info.label}</p>
                    <p className="text-white/40 text-xs font-noto">{info.sub}</p>
                  </div>
                ))}
              </div>

              <a
                href={RESERVATION_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full py-4 bg-[#d4af37] text-black font-bold text-center rounded-xl hover:bg-[#e8c84a] transition-all duration-200 cursor-pointer whitespace-nowrap"
                onClick={() => setOpen(false)}
              >
                予約サイトへ進む
                <i className="ri-external-link-line ml-2" />
              </a>
              <p className="text-white/30 text-xs font-noto text-center mt-3">
                外部サイト（upnow.jp）に遷移します
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
